import React from 'react'
import Manager from '../../public/components/Manager'
import LeaveApplyDetail from './LeaveApplyDetail'
Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    columns: [
        { _text: '申请编号', minWidth: 250, search: true, },
        { _text: '假期项目', field: 'OutReason', minWidth: 150, search: true, filter: ['select'], },
        { _datetime: '开始时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
        { _datetime: '结束时间', minWidth: 150, flex: 10, filter: true, align: 'left' },
        // { _text: '职务代理人', minWidth: 150, search: true, },
        { _text: '申请人', minWidth: 150, search: true, },
        { _: 'taskName', field: '_TaskName' }
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        showDetail(props => <LeaveApplyDetail {...props} id={data.id} taskName={data.taskName} />)
    }
}

export default props => <Manager {...props} config={config} />